

























import Vue, { PropType } from 'vue';
import { CourseraCourseInstructor } from '~/models/coursera';

export default Vue.extend({
    name: 'InstructorSection',
    props: {
        instructors: {
            type: Array as PropType<CourseraCourseInstructor[]>,
            required: true,
        },
    },
});
